import * as React from "react";
import { BusinessAccount, MenuEntry, Person } from "../../../../../datatypes/businessaccounts/BusinessAccount";
import CountryUtil from "../../../../../uidispatcherapi/CountryUtil";

type Props = {
    businessAccount: BusinessAccount | undefined | null;
    activeAccountId: string;
    person: Person;
    setPageNumber: (pageNumber: number) => void;
};

export type MenuSectionLinks = {
    business: [
        {
            text?: string;
            url?: string;
            paged?: boolean;
            page?: {
                text: string;
                url: string;
            };
            title?: string;
        }
    ];
    personal: Array<MenuEntry>;
};

export function AccountFlyoutMenuSection(props: Props) {
    const menuSectionLinks: MenuSectionLinks | null = CountryUtil.getFlyoutConfig().menuSectionLinks || null;

    const renderMenuLink = (text: string, url: string, index: number) => {
        return (
            <div key={"menuentry-link" + index} className="menuentry-link">
                <a className="account-label menu-entry" href={url}>
                    {text}
                </a>
            </div>
        );
    };

    const renderSubMenuLink = (label: string, index: number) => {
        return (
            <div
                key={`sub-menu-link-${index}`}
                className="menuentry-link menuentry-label"
                data-id="1"
                onClick={() => props.setPageNumber(3)}>
                <div className="menuentry account-label">{label}</div>
                <div className="arrow-right" data-id="1">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="24px"
                        height="24px"
                        viewBox="0 0 32 32"
                        version="1.1">
                        <defs>
                            <path
                                d="M12.300423,7.285875 C12.694423,6.898875 13.328423,6.904875 13.714423,7.299875 L21.714423,15.463875 C22.095423,15.852875 22.095423,16.475875 21.714423,16.863875 L14.035423,24.699875 C13.648423,25.094875 13.015423,25.100875 12.620423,24.713875 C12.226423,24.326875 12.221423,23.694875 12.606423,23.299875 L19.600423,16.163875 L12.286423,8.699875 C12.095423,8.504875 12.000423,8.252875 12.000423,7.999875 C12.000423,7.739875 12.100423,7.480875 12.300423,7.285875 Z"
                                id="pathlink"
                            />
                        </defs>
                        <g id="Icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Icon-/-medium-/-chevron-right">
                                <rect id="fill" x="0" y="0" width="32" height="32" />
                                <mask id="mask-2" fill="white">
                                    <use xlinkHref="#pathlink" />
                                </mask>
                                <use id="color" fill="#002d72" xlinkHref="#pathlink" />
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
        );
    };
    function renderMenuSectionLinks(isPerson: boolean) {
        if (!menuSectionLinks) {
            return null;
        }
        if (isPerson) {
            return menuSectionLinks.personal.map((item, index) => {
                const url = item.url;
                return renderMenuLink(item.text, url, index);
            });
        }
        return menuSectionLinks.business.map((item, index) => {
            if (item.text && item.url) {
                const url = item.url.replace("$account-id", props.activeAccountId);
                return renderMenuLink(item.text, url, index);
            }
            return renderSubMenuLink(item.title || "", index);
        });
    }

    if (!BusinessAccount) {
        return null;
    }
    return <div className="menusection">{renderMenuSectionLinks(props.activeAccountId === props.person.id)}</div>;
}
